import { lazy } from "react"

export const CarriersPage = lazy(() => import("./CarriersPage"))